// Taki turleri TEK kaynaktan gelir: urun tipi profilleri.
//
// Katalog ile Konsept Fotograflari ayri listeler kullanirken tipler
// tutmuyordu (katalogta "kupe" secilen urun, konseptlerde karsiligi olmayan
// bir anahtarla eslesiyordu). Ikisi de artik bu listeyi okur; sunucu
// cevap vermezse yerel liste devreye girer, ekran bos kalmasin.

import { useQuery } from "@tanstack/react-query";
import { authHeaders, getBackendUrl } from "./http";
import { JEWELRY_TYPE_KEYS, JEWELRY_TYPE_LABELS } from "./jewelryType";

export interface JewelryType {
  key: string;
  label: string;
}

const FALLBACK: JewelryType[] = JEWELRY_TYPE_KEYS.map((k) => ({
  key: k,
  label: JEWELRY_TYPE_LABELS[k] ?? k,
}));

export function useJewelryTypes(): JewelryType[] {
  const { data } = useQuery({
    queryKey: ["product-types", "jewelry"],
    queryFn: async (): Promise<JewelryType[]> => {
      const r = await fetch(`${getBackendUrl()}/api/product-types?vertical=jewelry`, {
        headers: authHeaders(),
      });
      if (!r.ok) return [];
      const rows = ((await r.json()).data ?? []) as Array<{ key: string; label: string }>;
      return rows.map((x) => ({ key: x.key, label: x.label || x.key }));
    },
    staleTime: 5 * 60_000,
  });

  return data && data.length > 0 ? data : FALLBACK;
}
